import {
    createHighlightBadgeComponent,
    HighlightBadge,
} from '@vfde-brix/highlight-badge';

/**
 * Highlight badge container
 *
 * @param container
 */
const mountHighlightBadge = (container): HighlightBadge => {
    return createHighlightBadgeComponent(container, {});
};

export default mountHighlightBadge;
